import React, { useEffect, useState } from 'react';
import { Loader2, Search } from 'lucide-react';
import { actionApi } from './drGActions';

const when = (s) => (s ? new Date(s.replace(' ', 'T')).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '');

export const LookupCard = ({ action }) => {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => { actionApi.findPatients(action.query).then(setRows).catch((e) => setErr(e.message)); }, [action.query]);
  return (
    <div className="rounded-xl border border-sky-200 bg-white p-3 text-sm" data-testid="dr-g-lookup-card">
      <p className="font-semibold text-slate-800 flex items-center gap-1.5 mb-2"><Search className="w-4 h-4 text-sky-600" /> Patient lookup: "{action.query}"</p>
      {err && <p className="text-rose-600">{err}</p>}
      {!rows && !err && <Loader2 className="w-4 h-4 animate-spin text-slate-400" />}
      {rows && !rows.length && <p className="text-slate-500">No matching patients found.</p>}
      {rows?.map((p) => (
        <div key={p.id} className="border-t first:border-0 pt-2 first:pt-0 mt-2 first:mt-0" data-testid={`dr-g-lookup-patient-${p.id}`}>
          <p className="font-medium text-slate-900">{p.firstName} {p.lastName}</p>
          <p className="text-xs text-slate-500">{[p.email, p.phone, p.preferredLanguage].filter(Boolean).join(' · ')}{p.createdAt ? ` · added ${when(p.createdAt)}` : ''}</p>
          {p.recent.length ? (
            <ul className="mt-1 space-y-0.5 text-xs text-slate-600">
              {p.recent.map((r, i) => <li key={i}><span className="text-slate-400">{when(r.at)}</span> · {r.source}{r.note ? `: ${r.note}` : ''}</li>)}
            </ul>
          ) : <p className="text-xs text-slate-400 mt-1">No recent activity.</p>}
          <a href="/" className="text-xs text-sky-700 underline">Open Patient Records</a>
        </div>
      ))}
    </div>
  );
};
